<template>
    <div>
        <div class="select_search m_bottom_15">
            <vue-multiselect
                v-model="model"
                :id="`select_${_uid}`"
                :options="dealOptions"
                :allow-empty="false"
                :placeholder="$t('search') + `...`"
                :custom-label="customLabel"
                :block-keys="['Tab']"
                selectLabel=""
                selectedLabel=""
                deselectLabel=""
                label="email"
                track-by="id"
                :searchable="true"
                :loading="isSearching"
                :internal-search="false"
                :clear-on-select="true"
                :close-on-select="true"
                :options-limit="300"
                :limit="8"
                :show-labels="true"
                :hasEmail="hasEmail"
                :disabled="disabled"
                @search-change="asyncGetAll"
            >
                <template slot="option" slot-scope="props">
                    <div class="clearfix d_flex">
                        <div class="min_w_50">
                            <img class="img-circle thumb-40" :src="props.option.lead.avatar || `/static/images/avatar.jpg`">
                        </div>
                        <div>
                            <p class="option__title t_overflow bold m-0">#{{ props.option.code }} - <span v-if="props.option.lead.full_name">{{ props.option.lead.full_name }}</span></p>
                            <small class="option__small t_overflow show" v-if="props.option.lead.email">({{ props.option.lead.email }})</small>
                        </div>
                    </div>
                </template>
                <p slot="noResult" class="p-10 m-0"><i class="fa fa-exclamation-triangle"></i> {{ $t('no_records_found') }}</p>
            </vue-multiselect>
        </div>
        <div v-if="model">
            <div class="p-10">
                <div class="row">
                    <div class="col-xs-12 col-sm-6 col-md-7">
                        <div class="d_table w_full">
                            <div class="d_t_cell w_50">
                                <a :href="`/leads/${model.lead.id}`" target="_blank" class="pull-left m-r-10">
                                    <img class="img-circle thumb-md" :src="model.lead.avatar || `/static/images/avatar.jpg`">
                                </a>
                            </div>
                            <div class="d_t_cell">
                                <a :href="`/leads/${model.lead.id}`" target="blank">
                                    <p class="option__title bold m-0 f_size_14">{{ model.lead.full_name }}</p>
                                </a>
                                <small class="option__small c_default show bold">{{ model.lead.email }}</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-5">
                        <div class="m-t-15 t_right">
                            <a :href="`/deals/${model.id}`" target="blank">
                                <b class="m-r-10">#{{ model.code }}</b>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { isEmpty, debounce, isNull } from 'lodash'
    import { getAll, getRaw } from 'services/deals'

    export default {
        name: 'DealSelect',
        props: {
            'value': {
                default: () => ''
            },
            'disabled': {
                type: Boolean,
                default: () => false
            },
            'hasEmail': {
                type: Number,
                default: () => 0
            },
            'exactDeal': {
                type: Number,
                default: () => null
            }
        },
        data () {
            return {
                search: null,
                isSearching: false,
                dealOptions: [],
                model: ''
            }
        },
        mounted () {
            this.model = this.value

            if (!isNull(this.exactDeal))
                this.asyncGet()
        },
        watch: {
            value (val, old) {
                if (val !== old)
                    this.model = this.value
            },
            model (val, old) {
                if (val !== old)
                    this.$emit('input', val)
            }
        },
        methods: {
            asyncGetAll: debounce(function (query) {
                if (isEmpty(query)) return

                this.isSearching = true

                getAll({identity: query, has_email: this.hasEmail})
                    .then(response => {
                        this.dealOptions = response.data
                        this.isSearching = false
                    })
            }, 500),
            asyncGet: debounce(function () {
                this.isSearching = true

                getRaw(this.exactDeal)
                    .then(response => {
                        this.model = response.data
                        this.isSearching = false
                    })
            }, 500),
            customLabel (opt) {
                return `${opt.lead.full_name} – (${opt.lead.email})`
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/form/selects/Deals.vue